"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var React = require("react");
var history_1 = require("./history");
var recommend_1 = require("./recommend");
require("./search-recommend.scss");
var stat_1 = require("~@/widget/stat/stat");
var history = new history_1.History();
var recommend = new recommend_1.Recommend();
var SearchRecommend = (function (_super) {
    __extends(SearchRecommend, _super);
    function SearchRecommend(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            historys: history.historys,
            currentIndex: -1,
            recommends: []
        };
        return _this;
    }
    SearchRecommend.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.enablePopup !== this.props.enablePopup) {
            this.setState({
                currentIndex: -1
            });
        }
    };
    SearchRecommend.prototype.render = function () {
        var _this = this;
        var _a = this.state, historys = _a.historys, recommends = _a.recommends, currentIndex = _a.currentIndex;
        var enablePopup = this.props.enablePopup;
        return (React.createElement("div", { className: "p-header__drag p-header__drag--history " + (enablePopup ? 'p-header__drag--show' : '') + " " + (historys.length ? 'p-header__drag--with-history' : '') },
            React.createElement("span", { className: "p-header__drag__enterstage" },
                React.createElement("i", { className: "p-header__drag__enterstage__tri" }),
                React.createElement("i", { className: "p-header__drag__enterstage__tri2" })),
            React.createElement("div", { className: "p-header__drag__main" },
                React.createElement("div", { className: "p-header__search-history" },
                    React.createElement("div", { className: "p-header__search-history__s1" },
                        React.createElement("span", { className: "p-header__search-history__s1__tl" }, "\u6700\u8FD1\u641C\u7D22"),
                        React.createElement("a", { className: "p-header__history__cnt__s1__clean", href: "javascript:;", onClick: this.handelClearHistory.bind(this) },
                            React.createElement("i", { className: "p-header__history__cnt__s1__clean__icon" }),
                            React.createElement("span", { className: "p-header__history__cnt__s1__clean__t" }, "\u6E05\u7A7A"))),
                    React.createElement("ul", { className: "p-header__search-history__s2" }, historys.map(function (str, index) {
                        return (React.createElement("li", { className: "p-header__search-history__s2__item " + (currentIndex === index ? 'p-header__search-history__item--hover' : ''), key: index, "data-keyword": str },
                            React.createElement("span", { className: "p-header__search-history__s2__item__cnt", onClick: _this.search.bind(_this, str, 'history') }, str),
                            React.createElement("span", { className: "p-header__search-history__s2__item__icon", onClick: _this.handleDelHistory.bind(_this, str) },
                                React.createElement("i", null))));
                    }))),
                React.createElement("div", { className: "p-header__search-recommend" },
                    React.createElement("div", { className: "p-header__search-recommend__tl" }, "\u70ED\u95E8\u641C\u7D22"),
                    React.createElement("ul", { className: "p-header__search-recommend__cnt" }, recommends.map(function (str, index) {
                        return (React.createElement("li", { className: "p-header__search-recommend__cnt__item " + (currentIndex === historys.length + index ? 'p-header__search-history__item--hover' : ''), key: index + 1, "data-keyword": str },
                            React.createElement("span", { className: "p-header__search-recommend__cnt__item__index p-header__search-recommend__cnt__item__index--" + (index + 1) }, index + 1),
                            React.createElement("span", { className: "p-header__search-recommend__cnt__item__t", onClick: _this.search.bind(_this, str, 'recommend') }, str)));
                    }))))));
    };
    SearchRecommend.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var hotData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, recommend.fetch()];
                    case 1:
                        hotData = _a.sent();
                        this.setState({
                            recommends: hotData
                        });
                        return [2];
                }
            });
        });
    };
    SearchRecommend.prototype.handleDelHistory = function (str, e) {
        history.del(str);
        this.setState({
            historys: history.historys
        });
    };
    SearchRecommend.prototype.handelClearHistory = function () {
        history.clear();
        this.setState({
            historys: history.historys
        });
        stat_1.stat(stat_1.EStatType.SEARCH_HISTORY_CLEAR);
    };
    SearchRecommend.prototype.search = function (str, type) {
        history.add(str);
        this.props.search(str);
        switch (type) {
            case 'history':
                stat_1.stat(stat_1.EStatType.SEARCH_HISTORY_ITEM_CLICK, [str]);
                break;
            case 'recommend':
                stat_1.stat(stat_1.EStatType.SEARCH_RECOMMEND_ITEM_CLICK, [str]);
                break;
        }
    };
    SearchRecommend.prototype.onSubmit = function (val) {
        history.add(val);
    };
    SearchRecommend.prototype.changeCurrent = function (offset) {
        var _a = this.state, historys = _a.historys, recommends = _a.recommends, currentIndex = _a.currentIndex;
        var setKeyword = this.props.setKeyword;
        var length = historys.length + recommends.length;
        var nextIndex = (currentIndex + offset) % length;
        if (currentIndex === -1 && offset < 0) {
            nextIndex += 1;
        }
        if (nextIndex < 0) {
            nextIndex = length + nextIndex;
        }
        var txt = historys.concat(recommends)[nextIndex];
        this.setState({
            currentIndex: nextIndex
        });
        setKeyword(txt);
    };
    return SearchRecommend;
}(React.Component));
exports.SearchRecommend = SearchRecommend;
